import {
  Box,
  Grid,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  title: {
    color: theme.palette.tab.offselected,
    fontWeight: 400,
  },
  containerTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
}));

type titleSectionProps = {
  title: string,
  children: React.ReactNode,
  actionButton?: React.ReactNode
}
const TitleSection: FC<titleSectionProps> = ({ title, children, actionButton }) => {
  const classes = useStyles();
  return (
    <Box>
      <Grid container direction="column">
        <Grid item xs={12}>
          <Box className={classes.containerTitle}>
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
            {actionButton && actionButton}
          </Box>
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TitleSection;
